<template>
  <div class="gj-upload" :class="{ 'gj-upload-cannot-delete': !deletable }">
    <el-upload
      v-bind="$attrs"
      v-on="$listeners"
      :disabled="disabled || loading"
      :before-upload="proxyBeforeUpload"
      :http-request="customUpload"
      :before-remove="removeFile"
      :on-preview="downloadFile"
      :file-list="proxyFileList"
      :show-file-list="false"
      action=""
      :class="{ 'gj-image-uploader': type === 'image', 'gj-upload--loading': loading }"
    >
      <slot>
        <template v-if="type === 'image'">
          <div v-loading="loading" style="display: inline-block">
            <img
              v-if="imageUrl"
              :src="imageUrl"
              class="gj-image"
              :style="{ height: imgHeight, width: imgWidth, lineHeight: imgHeight }"
              alt="图片"
            />
            <i
              v-else
              class="el-icon-plus gj-image-uploader-icon"
              :style="{ height: imgHeight, width: imgWidth, lineHeight: imgHeight }"
            >
            </i>
          </div>
        </template>
        <template v-else>
          <gj-button
            :loading="loading"
            :disabled="disabled"
            :type="uploadBtnType"
            :plain="uploadPlain"
            font14
          >
            {{ text }}
          </gj-button>
          <span @click.stop.prevent>
            <gj-button
              v-if="isMeaningful(templateUrl)"
              @click.stop="templateDownload"
              type="primary"
              plain
              font14
              :disabled="downloadTemplateDisabled"
              class="download-template--text"
            >
              下载模板
              <i v-if="templateDownloadLoading" class="el-icon-loading template-download-loading"></i>
            </gj-button>
          </span>
        </template>
      </slot>
    </el-upload>

    <template v-if="proxyShowFileList">
      <span class="gj-upload-info-box">
        <div class="gj-upload-info" v-for="(item, index) in proxyFileList" :key="item.uid">
          <!-- 文件列表 -->
          <div class="gj-upload_details">
            <div
              :class="{ 'special-upload': specialUpload }"
              @click="specialUpload && downloadErrFile(item.attId)"
            >
              <i class="el-icon-document"></i>
              <span class="file-name">{{ item.name }}</span>
              <i class="el-icon-delete" v-if="specialUpload" @click.stop="removeFile(item)"></i>
            </div>
            <div>
              <span v-if="item.isStatus === 1">
                <i class="el-icon-circle-check"></i>
                <span style="color: #2da641">上传成功</span>
              </span>
              <span v-if="item.isStatus === 3">
                <i class="el-icon-warning-outline"></i>
                <span style="color: #f00000">上传失败</span>
              </span>
            </div>
          </div>
          <div class="gj-upload_errmsg" v-if="item.isStatus === 2">
            <div>
              <div>{{ item.errMsg }}</div>
              <div v-if="uploadText">{{ uploadText }}</div>
            </div>
            <div class="gj-upload_errmsg-right">
              <div class="gj-upload_errmsg-dow">
                <i class="el-icon-download"></i>
                <span @click="downloadErrFile(item.fileId)">下载导入失败项</span>
              </div>
              <i class="el-icon-delete" @click="deleteFile(index)"></i>
            </div>
          </div>
        </div>
      </span>
      <!-- 进度条 -->
      <div class="gj-upload_progress" v-if="progressPercent !== 100 && progressPercent !== 0">
        <div class="gj-upload_details">
          <div>
            <i class="el-icon-document"></i>
            <span>{{ showName }}</span>
          </div>
          <div>{{ progressPercent }}%</div>
        </div>
        <el-progress
          :show-text="false"
          :stroke-width="4"
          :percentage="progressPercent"
        ></el-progress>
      </div>
    </template>

    <div v-if="!$slots.tip" class="gj-upload-tip">
      <slot name="tip"></slot>
    </div>
  </div>
</template>

<script>
import { FileTypeEnum } from './enum';
import {
  downloadAttFile,
  exportFile,
  removeAttachmentById,
  uploadFile,
  uploadFileImg,
} from '../../api/common';
import { isMeaningfulMixin, responseMixin } from '../../minxins';
import { isMeaningful } from '../../utils/common';

/**
 * 可接受类型 acceptType： 默认验证xlsx，xls（不需要验证文件类型将属性修改为空数组即可[]）
 * --当前文件夹下有个枚举文件
 * 上传成功之后发射一个 uploadAfter(附件id)供外部监听
 */
export default {
  name: 'gj-upload',
  mixins: [isMeaningfulMixin, responseMixin],
  props: {
    //用于行内导入
    row: {
      type: Object,
      default: () => {},
    },
    imageUrl: {
      type: String,
    },
    imgHeight: {
      type: String,
      default: '100px',
    },
    imgWidth: {
      type: String,
      default: '100px',
    },
    downloadTemplateDisabled: {
      type: Boolean,
      default: false,
    },
    templateUrl: {
      type: String,
    },
    templateParams: {
      type: [Object, Array],
    },
    type: {
      type: String,
      default: 'default',
      validator: function (value) {
        return ['default', 'image'].indexOf(value) !== -1;
      },
    },
    uploadBtnType: {
      default: 'primary',
    },
    uploadPlain: {
      default: false,
    },
    text: {
      type: String,
      default: '点击上传',
    },
    deletable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    acceptType: {
      type: Array,
      default: () => {
        return [];
        // return [FileTypeEnum.XLSX, FileTypeEnum.XLS, FileTypeEnum.X_XLS];
      },
    },
    containerType: {
      type: String,
      default: '',
    },
    containerBizId: {
      default: null,
    },
    showFileList: {
      type: Boolean,
      default: true,
    },
    fileList: {
      type: Array,
      default: () => [],
    },
    beforeUpload: {
      type: Function,
      default: null,
    },
    // 校验文件大小 单位 mb
    validFileSize: {
      type: Number,
      default: 20,
    },
    fileRoleType: {
      type: String,
      default: 'private',
      validator: function (value) {
        return ['public', 'private'].indexOf(value) !== -1;
      },
    },
    specialUpload: {
      // 用于上传附件
      type: Boolean,
      default: false,
    },
    // 在调用gj-upload的父组件中定义，用于在返回的报文提示后，加提示文案（目前只有在成本中心导入中使用）
    uploadText: null,
  },
  watch: {
    fileList: {
      handler(fileList) {
        this.proxyFileList = fileList;
      },
      immediate: true,
    },
  },
  data() {
    return {
      proxyFileList: [],
      loading: false,
      templateDownloadLoading: false,
      init: true,
      progressPercent: 0, // 进度条
      showName: '', // 展示名
      setTime: null, //假进度条定时器
    };
  },
  computed: {
    proxyShowFileList() {
      if (this.type === 'image') {
        return false;
      }
      return this.showFileList;
    },
  },
  methods: {
    proxyBeforeUpload(file) {
      // 展示当前文件名
      this.showName = file.name;

      if (this.beforeUpload) {
        const valid = this.beforeUpload();
        if (!valid) {
          return false;
        }
      }
      if (this.type === 'image') {
        // if (![FileTypeEnum.JPG, FileTypeEnum.JPEG, FileTypeEnum.PNG].includes(file.type)) {
        //   return false;
        // }
      }
      if (
        isMeaningful(file.type) &&
        this.acceptType.length > 0 &&
        this.acceptType.indexOf(file.type) === -1
      ) {
        this.$gjMessage.error('导入的文件格式不支持');
        return false;
      }
      if (
        isMeaningful(this.validFileSize) &&
        isMeaningful(file.size) &&
        file.size / 1024 / 1024 > this.validFileSize
      ) {
        this.$gjMessage.error(`文件大小不能超过${this.validFileSize}M`);
        return false;
      }
      return true;
    },
    customUpload(data) {
      // axios获取进度 （文件太小只会调用一次）
      const onUploadProgress = (progressEvent) => {
        let percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        this.progressPercent = percent;
      };
      let formData = new FormData();
      formData.append('file', data.file);
      formData.append('bizType', this.containerType);
      formData.append('bizId', this.containerBizId);
      const vm = this;
      this.loading = true;
      Promise.resolve(this.fileRoleType)
        .then((fileRoleType) => {
          if (fileRoleType === 'public') {
            return uploadFileImg(formData);
          }
          return uploadFile(formData, onUploadProgress);
        })
        .then((result) => {
          this.$gjResponseHandle(result, () => {
            // debugger
            let fileData = {
              uid: data.file.uid,
              attId: result.data.id,
              fileId: result.data.id,
              name: data.file.name,
              url: result.data.url,
            };
            // 用于upload和父组件的校验接口通信
            const uploadCb = (res) => {
              if (res === 'error') {
                fileData.isStatus = 3;
                return;
              }
              if (!this.proxyShowFileList) {
                // 上传图片跳过此方法
                return;
              }
              fileData.errMsg = res.msg;
              if (isMeaningful(res.data) && isMeaningful(res.data.fileId)) {
                // 上传成功导入不完全 data会有数据
                fileData.fileId = res.data.fileId;
                fileData.isStatus = 2; //  isStatus 1为完全成功  2为上传成功但导入的数据不完全或者异常  3为完全失败
              } else {
                fileData.isStatus = 1;
              }
            };
            // 上传失败
            if (result.code !== 0) {
              fileData.isStatus = 3;
            }
            // 父组件未执行 uploadAfter 则触发此方法
            if (!this.$listeners.uploadAfter) {
              fileData.isStatus = result.code === 0 ? 1 : 3;
            }
            vm.proxyFileList.push(fileData);
            this.$emit('update:fileList', vm.proxyFileList);
            if (this.type === 'image') {
              this.$emit('update:imageUrl', result.data.url);
            }
            // 失败后结束方法
            if (fileData.isStatus === 3) {
              return;
            }
            vm.$emit('uploadAfter', result.data.id, result.data, uploadCb, this.row, data);
          });
        })
        .complete(() => (this.loading = false));
    },
    downloadFile(file) {
      downloadAttFile(file.attId);
    },
    removeFile(file, fileList) {
      const vm = this;
      if (isMeaningful(file.attId)) {
        removeAttachmentById(file.attId).then(() => {
          vm.proxyFileList = vm.proxyFileList.filter((v) => v.attId !== file.attId);
          this.$emit('update:fileList', vm.proxyFileList);
        });
      }
    },
    templateDownload() {
      this.templateDownloadLoading = true;
      exportFile(this.templateUrl, this.templateParams).complete(
        () => (this.templateDownloadLoading = false),
      );
    },
    // 下载导入失败的文件
    downloadErrFile(fileId) {
      downloadAttFile(fileId);
    },
    // 删除文件
    deleteFile(index) {
      this.proxyFileList.splice(index, 1);
    },
  },
};
</script>


<style lang="scss">
.gj-upload-info {
  margin: 12px 0;
  .gj-upload_details {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 17px;
    span {
      margin-left: 4px;
      font-size: 13px;
      color: #333333;
    }
    .el-icon-warning-outline {
      color: #f00000;
      font-size: 15px;
    }
    .el-icon-circle-check {
      font-size: 15px;
      color: #2da641;
    }
  }
  .gj-upload_errmsg {
    font-size: 12px;
    padding: 4px 17px;
    // padding-left: 17px;
    margin-top: 4px;
    background: #fff1f0;
    color: #f5222d;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .gj-upload_errmsg-right {
      display: flex;
      align-items: center;
      .gj-upload_errmsg-dow {
        margin-right: 16px;
        color: #333333;
        cursor: pointer;
      }
      .el-icon-delete {
        color: #333333;
        font-size: 14px;
        cursor: pointer;
      }
      .el-icon-download {
        // font-size: 14px;
        margin-right: 4px;
      }
    }
  }
}
.gj-upload_progress {
  padding: 16px 0;
  .gj-upload_details {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
    font-size: 13px;
  }
}
.special-upload {
  display: flex;
  align-items: center;
  padding-right: 40px;
  position: relative;
  /deep/ .el-icon-delete {
    font-size: 14px;
    position: absolute;
    right: 0;
    display: none;
  }
  &:hover {
    background-color: #edf7ff;
    cursor: pointer;
    /deep/ .el-icon-delete {
      display: inline-block;
    }
  }
}
</style>

<style scoped>
.gj-upload {
  line-height: normal;
}
/* .gj-upload div:first-child {
    display: inline-block;
  } */

.download-template--text {
  margin-left: 12px;
}

.gj-upload-tip {
  font-size: 12px;
  color: #606266;
  margin-top: 5px;
}

.gj-avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.gj-image-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  line-height: normal;
}

.gj-image-uploader:not(.gj-upload--loading) /deep/ .el-upload:hover {
  border-color: #1f6eef;
}

.gj-image-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}

.gj-image {
  display: block;
}

.gj-upload-error {
  margin-top: 10px;
  cursor: pointer;
}

.gj-upload-error-styl {
  font-size: 12px;
  display: inline-block;
  min-width: 170px;
  margin-right: 18px;
}

.gj-upload-error:hover {
  background-color: #f5f7fa;
  color: #1f6eef;
}
/deep/ .el-upload-list__item-name {
  padding-left: 0;
}
.gj-upload-error-file-icon {
  font-size: 14px;
  height: 100%;
  margin-right: 7px;
  color: #909399;
  line-height: inherit;
}
.gj-upload-cannot-delete /deep/ .el-icon-close-tip,
.gj-upload-cannot-delete /deep/ .el-icon-close,
.gj-upload-cannot-delete /deep/ .el-upload-list__item-status-label {
  display: none;
}
</style>
